/**
 * 可拖拽列表组件
 * 统一封装 vuedraggable，支持递归渲染字段行
 * 纯渲染组件，不处理业务逻辑
 */

import Draggable from 'vuedraggable'
import FieldRow from './field-row'
// import { DRAG_OPTIONS, FIELD_PROPS, ROW_NUMBER } from '../constants'
import { FIELD_PROPS } from '../constants'

export default {
  components: { Draggable, FieldRow },
  props: {
    fields: {
      type: Array,
      default: () => ([])
    },
    className: {
      type: String,
      default: ''
    },
    level: {
      type: Number,
      default: 0
    },
    activeKey: {
      type: String,
      default: ''
    }
  },
  methods: {
    handleShowChange(val, row) {
      this.$emit('showChange', val, row)
    },
    handleFixedChange(val, row) {
      this.$emit('fixedChange', val, row)
    },
    handleMove(val, row) {
      this.$emit('move', val, row)
    }
  },
  render() {
    const { fields, level, className, activeKey } = this
    const warpClass = `kye-field-settings-draggable-list ${className}`

    const renderRows = (list, currentLevel = 0) => {
      const totalRows = list.length
      return list.map((item, index) => {
        return (
          <FieldRow
            key={item[FIELD_PROPS.KEY]}
            row={item}
            level={currentLevel}
            rowIndex={index}
            totalRows={totalRows}
            activeKey={activeKey}
            onShowChange={this.handleShowChange}
            onFixedChange={this.handleFixedChange}
            onMove={this.handleMove}
          />
        )
      })
    }

    return (
      <Draggable
        tag="div"
        class={warpClass}
        list={fields}
        // group={group}
        // {...{ props: DRAG_OPTIONS }}
        // onEnd={this.handleDragEnd}
      >
        {renderRows(fields, level)}
      </Draggable>
    )
  }
}



// WEBPACK FOOTER //
// ./src/public/components/kye-field-settings/components/draggable-list.js